import React from 'react';
import {AuthService} from '../../services/auth';

export function Name({id, firstName, lastName, includeID}) {
    const [name, setName] = React.useState();
    React.useEffect(() => {
        setName(AuthService.name({id, firstName, lastName, includeID}));
    }, []);

    return (
        <div title={id}>{name}</div>
    )
}
